import {
  wrapCall,
  embedsToQuery,
  callGet,
  callPost,
  callDelete
} from './helpers'

//* ~~~~~~ STACKS ROUTES ~~~~~~

// Initial get of peer chat stack
export const getStack = async stack => {
  return await wrapCall({
    method: callGet,
    uri: `/stacks/${stack}${embedsToQuery(['unread'])}`
  })
}

// Posting to stack (peer chat)
export const postStack = async (data, stack) => {
  return await wrapCall({
    method: callPost,
    uri: `/stacks/${stack}`,
    data,
    rawError: true
  })
}

// Deleting convo/session from peer chat stack
export const removeFromStack = async (id, stack) => {
  return await wrapCall({
    method: callDelete,
    uri: `/stacks/${stack}/${id}`
  })
}
